import React, { useState, useEffect } from 'react';
import { collection, getDocs, query } from 'firebase/firestore';
import { db } from '../../firebaseOptions';
import { Link } from 'react-router-dom';
import HeroCarousel from './HeroCarousel';
import './Main.css';

export default function Main() {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlbums = async () => {
      try {
        const q = query(collection(db, 'albums'));
        const querySnapshot = await getDocs(q);
        const albumsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setAlbums(albumsData);
      } catch (error) {
        console.error('Error fetching albums', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAlbums();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          height: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: 'Montserrat, sans-serif',
          letterSpacing: '2px',
        }}
      >
        CARGANDO PORTFOLIO...
      </div>
    );
  }

  return (
    <div className="main-container">
      <HeroCarousel />

      <div className="portfolio-grid-section">
        <div className="portfolio-grid">
          {albums.map((album) => (
            <Link
              to={`/proyecto/${album.id}`}
              key={album.id}
              className="grid-item"
            >
              <div className="grid-image-wrapper">
                {album.images && album.images.length > 0 ? (
                  album.images[0].includes('.mp4') ? (
                    <video src={album.images[0]} muted />
                  ) : (
                    <img src={album.images[0]} alt={album.title} />
                  )
                ) : (
                  <div className="placeholder">No Img</div>
                )}
                <div className="grid-overlay">
                  <h3>{album.title}</h3>
                  <span>VER PROYECTO</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
